import periods from "./Periods.js"
import sizeEnum from "./SizeEnum"
import sharedFilterString from '@/filters/sharedFilterString.js'

export default {
  id : 4,
  title : "OPEX UG Mining Development Drilling",
  template : "pageA",
  i18n : "ABC.Development.Drilling",
  link : "/abc/kpi/opex/ugmining/development/drilling",
  layout : {
    upper1 : {
      name : "OPEX",
      type : "radialBar",
      i18n : "ABC.OPEX.BaseValue",
      url: "/Hyperion/Kpi/OPEXUGMiningDevelopmentDrilling",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "KPI_M_k_formatter"
      },
      zoomIn : {
        name : "OPEX Periodic",
        i18n : "ABC.Development.Title",
        type : "comparaisonLine",
        url: "/Hyperion/Kpi/PeriodicOPEXUGMiningDevDrilling",
        chartData : {
          categories : periods,
          leftDataTitle: "Actual",
          leftDataTitlei18n: "Actual",
          rightDataTitle: "Budget",
          rightDataTitlei18n: "Budget",
          dataFilter: "KPI_M_k_formatter"
        }
      }
    },
    upper2 : {
      name : "OPEX Per Madv",
      i18n : "ABC.OPEX.OPEXPerMadv",
      type : "radialBar",
      url: "/Hyperion/Kpi/OPEXUGMiningDevDrillingPerMadv",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "k_formatter"
      },
      zoomIn : {
        name : "Meter of advance",
        i18n : "ABC.MeterOfAdvance",
        type : "comparaisonBar",
        url: "/Hyperion/Kpi/PeriodicMeterOfAdvance",
        chartData : {
          categories : periods,
          yAxisTitle: "Advance (m)"
        }
      }
    },
    upper3 : {
      name : "OPEX Per Mdrl",
      i18n : "ABC.OPEX.OPEXPerMdrl",
      type : "radialBar",
      url: "/Hyperion/Kpi/OPEXUGMiningDevDrillingPerMdrl",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "2Digits"
      },
      zoomIn : {
        name : "Meter Drilled",
        i18n : "ABC.MeterDrilled",
        type : "basicColumn",
        url: "/Hyperion/Kpi/MeterDrilled",
        chartData : {
          categories : ["M"],
          yAxisTitle: "Dev Drilling (m)"
        }
      }
    },
    upper4 : {
      name : "OPEX Per Mdrl",
      i18n : "ABC.OPEX.OPEXPerTDev",
      type : "radialBar",
      url: "/Hyperion/Kpi/OPEXUGMiningDevDrillingPerTDevOre",
      chartData : {
        leftDataTitle: "Actual",
        leftDataTitlei18n: "Actual",
        rightDataTitle: "Budget",
        rightDataTitlei18n: "Budget",
        dataFilter: "2Digits"
      },
      zoomIn : {
        name : "Meter Drilled",
        i18n : "ABC.UGDevelopmentOre",
        type : "basicColumn",
        url: "/Hyperion/Kpi/UGDevelopmentOre",
        chartData : {
          categories : ["TDev"],
          yAxisTitle: "UG Dev Ore (mT)"
        }
      }
    },
    middle1 : {
      name : "OPEX Per Madv",
      i18n : "ABC.OPEX.OPEXPerMadv",
      type : "comparaisonLine",
      url: "/Hyperion/Kpi/PeriodicOPEXUGMiningDevDrillingPerMadvVsMdrl",
      chartData : {
        categories : periods,
        leftDataTitle: "Madv",
        leftDataTitlei18n: "ABC.OPEX.OPEXPerMadv",
        rightDataTitle: "Mdrl",
        rightDataTitlei18n: "ABC.OPEX.OPEXPerMdrl",
        dataFilter: "2Digits"
      }
    },
    middle2 : {
      name : "OPEX Per Account",
      i18n : "ABC.DirectProductionExpensePerAccount",
      type : "basicDonut",
      url: "/Hyperion/Kpi/OPEXUGMiningDevDrillingPerAccount",
      chartData : {
        size : sizeEnum.Large,
        enableDrill: true,
        dataFilter: "KPI_M_k_formatter"
      }
    },
    middle3 : {
      name : "OPEX Per Account Table",
      i18n : "ABC.DirectProductionExpensePerAccount",
      type : "table",
      url: "/Hyperion/Kpi/OPEXUGMiningDevDrillingPerAccountDataTable",
      chartData : {
        columnDefs: [
          { field: 'accountName' },
          { 
            field: 'actual',
            width: 150,
            valueFormatter : sharedFilterString.toCurrency
          },
          { 
            field: 'budget',
            width: 150,
            valueFormatter : sharedFilterString.toCurrency
          }
        ]
      }
    },
    below1 : {
      name : "Workforce",
      i18n : "ABC.Workforce",
      type : "table",
      url: "/Hyperion/Kpi/WorkforceUGMiningDevDrillingPerTypeDataTable",
      chartData : {
        columnDefs: [
          { field: 'accountName' },
          { 
            field: 'actual',
            width: 150
          },
          { 
            field: 'budget',
            width: 150
          }
        ]
      }
    },
    below2 : {
      name : "Equipment",
      i18n : "ABC.Equipment.Units",
      type : "table",
      url: "/Hyperion/Kpi/EquipmentUGMiningDevDrillingPerTypeDataTable",
      chartData : {
        columnDefs: [
          { field: 'accountName' },
          { 
            field: 'actual',
            width: 150
          },
          { 
            field: 'budget',
            width: 150
          }
        ]
      }
    },
    below3 : {
      name : "Equipment",
      i18n : "ABC.Equipment.Performance",
      type : "table",
      url: "/Hyperion/Kpi/EquipmentStatsUGMiningDevDrillingPerTypeDataTable",
      chartData : {
        columnDefs: [
          { field: 'accountName' },
          { 
            field: 'actual',
            width: 150
          },
          { 
            field: 'budget',
            width: 150
          }
        ]
      }
    }
  }
}
  
